// Format duration helper
export const formatDuration = (seconds) => {
  if (!seconds) return '';
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  return `${minutes}m`;
};

// Format match minute (time since kickoff)
export const getMatchMinute = (startTime) => {
  if (!startTime) return '';
  const kickoff = new Date(startTime);
  const now = new Date();
  const diffMs = now - kickoff;
  if (diffMs < 0) return '';
  const minutes = Math.floor(diffMs / 60000);
  if (minutes > 90) return '90+';
  return `${minutes}'`;
};

// Format time ago
export const formatTimeAgo = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now - date;
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffHours / 24);
  
  if (diffDays > 0) return `${diffDays}d ago`;
  if (diffHours > 0) return `${diffHours}h ago`;
  return 'Just now';
};

// Get hero background URL with priority fallback
export const getHeroBackgroundUrl = (content, backgroundSource) => {
  if (!content) return '';
  
  switch (backgroundSource) {
    case 'team':
      return content.team_hero_image || content.hero_image || content.match_hero_image || content.thumbnail_url;
    case 'match':
      return content.hero_image || content.match_hero_image || content.thumbnail_url;
    case 'competition':
      return content.competition_hero_image || content.hero_image || content.thumbnail_url;
    default:
      return content.hero_image || content.thumbnail_url;
  }
};

// Check if starting soon (within 30 minutes)
export const isStartingSoon = (startTime) => {
  if (!startTime) return false;
  const kickoff = new Date(startTime);
  const now = new Date();
  const diffMs = kickoff - now;
  return diffMs > 0 && diffMs <= 30 * 60 * 1000;
};

// Check if upcoming within N hours
export const isUpcoming = (startTime) => {
  if (!startTime) return false;
  const kickoff = new Date(startTime);
  const now = new Date();
  const diffMs = kickoff - now;
  return diffMs > 0 && diffMs <= 12 * 60 * 60 * 1000;
};

// Check if upcoming within 3 hours (used for hero selection)
export const isUpcomingWithin3Hours = (startTime) => {
  if (!startTime) return false;
  const kickoff = new Date(startTime);
  const now = new Date();
  const diffMs = kickoff - now;
  return diffMs > 0 && diffMs <= 3 * 60 * 60 * 1000;
};

// Competition priority for sorting
export const COMPETITION_PRIORITY = {
  'CAF Champions League': 1,
  'AFCON': 2,
  'CAF Confederation Cup': 3,
  'CHAN': 4,
  'WAFCON': 5,
  'NPFL': 6,
  'PSL': 7
};

export const getCompetitionPriority = (name) => {
  if (!name) return 99;
  for (const [key, value] of Object.entries(COMPETITION_PRIORITY)) {
    if (name.toLowerCase().includes(key.toLowerCase())) return value;
  }
  return 99;
};

// Smart Match Status
export const getMatchStatus = (match) => {
  if (match.is_live) return 'live';
  if (!match.start_time) return 'future';
  const diff = new Date(match.start_time) - new Date();
  if (diff <= 0) return 'live';
  if (diff <= 60 * 60 * 1000) return 'soon';
  const today = new Date();
  const kickoff = new Date(match.start_time);
  if (kickoff.toDateString() === today.toDateString()) return 'today';
  return 'future';
};

export const formatCountdown = (startTime) => {
  const diff = new Date(startTime) - new Date();
  if (diff <= 0) return 'Now';
  const mins = Math.floor(diff / 60000);
  if (mins < 60) return `${mins}m`;
  const hrs = Math.floor(mins / 60);
  return `${hrs}h ${mins % 60}m`;
};

export const formatKickoff = (startTime) => {
  const d = new Date(startTime);
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

export const formatMatchDate = (startTime) => {
  const d = new Date(startTime);
  return d.toLocaleDateString([], { month: 'short', day: 'numeric' });
};
